import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useCms } from '../contexts/CmsContext';
import Header from './Header';
import Footer from './Footer';
import ScrollAnimation from './ScrollAnimation';
import { MdFilterList, MdExpandMore, MdArrowForward, MdArrowBack, MdExpandMore as MdExpandMoreIcon, MdVerifiedUser } from 'react-icons/md';
import CivilImage from '../assests/Civil.jpeg';
import FirefighterStationImage from '../assests/firefighter-station-with-suit-safety-helmet.jpg';
import HardwareImage from '../assests/hardware.jpg';
import MechanicalComponentsImage from '../assests/Mechanical_components.png';
import ElectricianPanelImage from '../assests/male-electrician-working-electrical-panel-male-electrician-overalls.jpg';
import SolventImage from '../assests/solvent.jpeg';
import TelecomImage from '../assests/telecom.png';
import DefaultProfilePdf from '../assests/AMHBM_Profile.pdf';

const Service = () => {
  const { language } = useLanguage();
  const { getContent } = useCms();
  const t = getContent(language);
  const s = t.servicePage;
  const isRTL = language === 'ar';

  // Determine the PDF URL to use:
  // If the CMS value matches the default path (or is empty), use the imported file (Webpack managed).
  // Otherwise, use the CMS provided URL (user uploaded).
  const catalogPdfUrl = (!s.catalogNav?.catalogPdf || s.catalogNav.catalogPdf === '/uploads/AMHBM_Profile.pdf')
    ? DefaultProfilePdf 
    : s.catalogNav.catalogPdf;

  const getSubcategoryItems = (key) => {
    if (s.categories && s.categories[key] && Array.isArray(s.categories[key].items)) {
      return s.categories[key].items;
    }
    return [];
  };

  const categories = [
    {
      key: 'pipes',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA0Hl2QWXPLPkh73Jqi60YcsQq3AeFb0mRTRMfdoUJ4bFMdgXqb7hZj5Q0s3fvbXr5z2NM7LeidBRHoL19gLLlqucPWwQvMvkr2mxFoGcXjjrC8OyYoyrkgeufmb6HTJsFX25aAjkGay-MMgVPxD4axLxTkEkPdrBpHx5silkGWsSuyM9ZoTnjJtVDsfxtOu-OWqvELMXw4Pq5pj6fSk-V4X1nkJ5dboBaqYrD9g6KyeUID1RdS19XKrU3e0GLn6oh3GkaEbyDKEg'
    },
    {
      key: 'flanges',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
    },
    {
      key: 'valves',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBRDqE_O0X6RhsNaXZAgCHsVazV02lZu2roOs3Tq-1esY6ykQv2fTUYCUXNSJtfmWf5Cz3WxZjsuB_noAlTaonSmHrs226HEd-6eTlc8Cx4zb_ovy1UUbM7eE4mmyPU258YTo0tqrrRvcwhP_owrl-p-7hdvZIdMt3_w8b3xki-NaKjdkrWPoWmZvgckkI5Om1zXTytmi2Lz4rEHsniRn0B0KCMIO213m8isCbkZnctMKvWpK1GvjvYLFe7Y6-lhPZfyIw6DZL6Dw'
    },
    {
      key: 'fire',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
    },
    {
      key: 'buttweld',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA0Hl2QWXPLPkh73Jqi60YcsQq3AeFb0mRTRMfdoUJ4bFMdgXqb7hZj5Q0s3fvbXr5z2NM7LeidBRHoL19gLLlqucPWwQvMvkr2mxFoGcXjjrC8OyYoyrkgeufmb6HTJsFX25aAjkGay-MMgVPxD4axLxTkEkPdrBpHx5silkGWsSuyM9ZoTnjJtVDsfxtOu-OWqvELMXw4Pq5pj6fSk-V4X1nkJ5dboBaqYrD9g6KyeUID1RdS19XKrU3e0GLn6oh3GkaEbyDKEg'
    },
    {
      key: 'forged',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBKG3pJr_t6KKYA-MN5l9_7xT3XyI_r6HaOoXJf6-D6qsK9-6mfShNCMkVWbzLIl_dXgrNX69tWCuAhUg-t3GQmyof_H0Y2LVccFWCj5cKvf-rUOG6c6Yr2ro3K4ouaU5MNc8sQur-_GeJLDXFCSvLih3nNQI9jt7xSRJ_EDWFwo20EYj1mhGBV1_d_I8PTfjqXufWbth4nzUM5z-YcW0DX2w1ftKgLg-tH_FWsKOLsHIuhz9aFqoePhF9TLpFXcDexb41IfsvTAw'
    },
    {
      key: 'instrumentation',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuBRDqE_O0X6RhsNaXZAgCHsVazV02lZu2roOs3Tq-1esY6ykQv2fTUYCUXNSJtfmWf5Cz3WxZjsuB_noAlTaonSmHrs226HEd-6eTlc8Cx4zb_ovy1UUbM7eE4mmyPU258YTo0tqrrRvcwhP_owrl-p-7hdvZIdMt3_w8b3xki-NaKjdkrWPoWmZvgckkI5Om1zXTytmi2Lz4rEHsniRn0B0KCMIO213m8isCbkZnctMKvWpK1GvjvYLFe7Y6-lhPZfyIw6DZL6Dw'
    },
    {
      key: 'structural',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCuSVURuZqWYciFzBJYudZaAiVLUuH2A2b2GGQ5E9v8c-VFT9DlRnhXRu0OmOnCNPBnhUAXqpJmUaHCM3h6MNUGHnhy6oNZdfTn_w5uRAdpGisk4Nj90dG32weGbsArRvFmHTGaRXAwaHDfjdNRyj1oFk_dTXS2vxSfnfAHr5cfvVNpb8oDCZN69ILQgg7sQMq35ULSmWMvBi6YxljvLo5O7rKwe8lGEyLvV-__r6zPvf-J0kGrbe3aA8fjvhm3MN7D6HeA59F1Gg'
    },
    {
      key: 'electrical',
      img: 'https://lh3.googleusercontent.com/aida-public/AB6AXuA0Hl2QWXPLPkh73Jqi60YcsQq3AeFb0mRTRMfdoUJ4bFMdgXqb7hZj5Q0s3fvbXr5z2NM7LeidBRHoL19gLLlqucPWwQvMvkr2mxFoGcXjjrC8OyYoyrkgeufmb6HTJsFX25aAjkGay-MMgVPxD4axLxTkEkPdrBpHx5silkGWsSuyM9ZoTnjJtVDsfxtOu-OWqvELMXw4Pq5pj6fSk-V4X1nkJ5dboBaqYrD9g6KyeUID1RdS19XKrU3e0GLn6oh3GkaEbyDKEg'
    }
  ];

  const [activeSection, setActiveSection] = useState('pipes');

  const navItems = [
    { id: 'pipes', icon: 'settings_input_hdmi', label: s.catalogNav?.items?.pipes || 'Pipes' },
    { id: 'fittings', icon: 'plumbing', label: s.catalogNav?.items?.fittings || 'Fittings' },
    { id: 'flanges', icon: 'settings', label: s.catalogNav?.items?.flanges || 'Flanges' },
    { id: 'valves', icon: 'valve', label: s.catalogNav?.items?.valves || 'Valves' },
    { id: 'fire', icon: 'fire_extinguisher', label: s.catalogNav?.items?.fire || 'Fire Hydrant & Grooved Fittings' },
    { id: 'instrumentation', icon: 'speed', label: s.catalogNav?.items?.instrumentation || 'Instrumentation Accessories' },
    { id: 'fasteners', icon: 'handyman', label: s.catalogNav?.items?.fasteners || 'Fasteners & Stud' },
    { id: 'gaskets', icon: 'circle', label: s.catalogNav?.items?.gaskets || 'Gasket & Insulation Kits' },
    { id: 'electrical', icon: 'bolt', label: s.catalogNav?.items?.electrical || 'Industrial Electrical' },
    { id: 'telecom', icon: 'cell_tower', label: s.catalogNav?.items?.telecom || 'Industrial Telecom' },
    { id: 'sanitary', icon: 'water_drop', label: s.catalogNav?.items?.sanitary || 'Sanitary' },
    { id: 'chemicals', icon: 'science', label: s.catalogNav?.items?.chemicals || 'Solvents & Chemicals' },
  ];

  const handleNavClick = (e, id) => {
    e.preventDefault();
    setActiveSection(id);
    
    const isMobile = window.innerWidth < 1024;
    const targetId = isMobile ? 'main-product-content' : 'category-content';
    const contentElement = document.getElementById(targetId);
    
    if (contentElement) {
      const headerOffset = 100;
      const elementPosition = contentElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const renderSubItem = (item, index) => {
    const isObject = typeof item === 'object' && item !== null;
    const isDetailed = isObject && item.type === 'detailed';
    
    const name = isObject ? item.name : item;
    const description = isObject ? item.description : '';
    const footerNote = isObject ? item.footerNote : null;
    
    // Normalize images - Take only the first one
    let image = null;
    if (isDetailed && item.images && item.images.length > 0) {
      image = item.images[0];
    } else if (isObject && item.image) {
      image = item.image;
    }

    const specs = isDetailed ? item.specs : null;

    return (
      <div key={index} className="group p-3 sm:p-5 bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 hover:shadow-xl hover:border-primary/20 transition-all duration-300 flex flex-col">
         {/* Single Image */}
         {image && (
           <div className="h-40 sm:h-48 w-full mb-4 overflow-hidden rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-slate-100 dark:border-slate-700/50 relative">
             <img 
               src={image} 
               alt={name} 
               className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" 
             />
             <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
           </div>
         )}
         
         <div className="flex items-center gap-3 mb-3">
           <div className="h-2 w-2 bg-primary rounded-full ring-4 ring-primary/10"></div>
           <h3 className="font-bold text-base sm:text-lg text-slate-900 dark:text-white uppercase tracking-wide leading-tight group-hover:text-primary transition-colors">{name}</h3>
         </div>
         
         <div className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed mb-4 flex-grow">
           {specs ? (
             <div className="space-y-3">
                {Object.entries(specs).slice(0, 4).map(([key, value]) => (
                   <div key={key} className="grid grid-cols-3 gap-2 border-b border-dashed border-slate-100 dark:border-slate-700/50 pb-2 last:border-0 last:pb-0">
                     <span className="font-bold text-[10px] sm:text-[11px] uppercase text-slate-400 tracking-wider pt-0.5">{key}</span>
                     <div className="col-span-2 text-slate-700 dark:text-slate-300 font-medium text-xs sm:text-sm">
                       {Array.isArray(value) ? (
                           <span className="line-clamp-2">{value.join(', ')}</span>
                       ) : (
                           <span className="line-clamp-2">{value}</span>
                       )}
                     </div>
                   </div>
                ))}
             </div>
           ) : (
             description && (
               <p className="line-clamp-3 text-xs sm:text-sm font-light">
                 {description}
               </p>
             )
           )}
         </div>
         
         <div className="pt-6 border-t border-slate-100 dark:border-slate-700/50 text-xs font-semibold text-primary/80 flex items-center gap-2 bg-slate-50 dark:bg-slate-800/50 -mx-6 -mb-6 px-6 py-4 mt-auto">
           <MdVerifiedUser className="text-base" />
          {footerNote || (isRTL ? 'مقاسات ودرجات خاصة متاحة عند الطلب' : 'Special sizes & grades available')}
        </div>
      </div>
    );
  };

  const getBadges = (key) => {
    switch (key) {
      case 'pipes': return [s.badges.aramcoApproved, s.badges.sabicReady];
      case 'valves': return [s.badges.api6d, s.badges.aramcoApproved];
      case 'fire': return [s.badges.ulListed, s.badges.fmApproved];
      case 'electrical': return [s.badges.ulListed, s.badges.sabicReady];
      case 'instrumentation': return [s.badges.aramcoApproved, s.badges.sabicReady];
      default: return [s.badges.aramcoApproved, s.badges.sabicReady];
    }
  };

  const currentCategoryData = s.categories?.[activeSection];

  return (
    <div
      dir={isRTL ? 'rtl' : 'ltr'}
      className={`${
        isRTL ? 'font-cairo rtl' : 'font-sans ltr'
      } bg-white text-slate-900 transition-colors duration-300 animate-fade-in`}
    >
      <Header />

      <section className="relative h-[40vh] min-h-[300px] md:min-h-[400px] flex items-start md:items-center overflow-hidden pt-32 md:pt-20 bg-background-light dark:bg-[#11211c]">
         <div className="absolute inset-0 z-0">
             {(s.hero?.bgImage || currentCategoryData?.image) && (
                <>
                  <img 
                    src={s.hero?.bgImage || currentCategoryData?.image} 
                    alt="Background" 
                    className="w-full h-full object-cover opacity-100"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-light dark:from-[#11211c] to-transparent" />
                </>
            )}
         </div>
        <div className="relative z-10 px-6 lg:px-12 max-w-[1440px] mx-auto w-full">
          <div className="max-w-3xl pb-10 md:pb-0">
            <ScrollAnimation animation="fade-up">
              <span className={`inline-block text-primary text-[10px] sm:text-xs font-bold ${isRTL ? '' : 'tracking-[0.3em]'} uppercase mb-4`}>
                {s.hero.badge}
              </span>
              <h1 className="text-slate-900 dark:text-white text-3xl sm:text-4xl md:text-6xl font-black mb-6 leading-tight">
                {s.hero.titleLine1}
                <br />
                <span className="text-primary">{s.hero.titleEmphasis}</span>
              </h1>
              <p className="text-slate-600 dark:text-gray-300 text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-xl">
                {s.hero.subtitle}
              </p>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      <main className="py-12 pb-24 md:py-24 bg-white dark:bg-[#0d1815]" id="category-content">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row gap-8 px-6 lg:px-12">
          {/* Sidebar Navigation */}
          <aside className="w-full lg:w-72 flex-shrink-0">
            <div className="sticky top-24 bg-white dark:bg-[#11211c] rounded-2xl p-4 sm:p-6 border border-industrial-silver dark:border-[#2a3c36] shadow-sm">
              <h2 className={`text-xs font-bold uppercase ${isRTL ? '' : 'tracking-widest'} text-[#63887d] mb-6`}>
                {s.catalogNav.title}
              </h2>
              <nav className="flex flex-col gap-2">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    className={`group w-full flex items-center gap-3 px-3 py-2 sm:px-4 sm:py-3 rounded-xl transition-all duration-200 ${isRTL ? 'text-right' : 'text-left'} ${
                      activeSection === item.id
                        ? 'bg-primary text-white shadow-lg shadow-primary/30 transform scale-105'
                        : 'hover:bg-gray-100 dark:hover:bg-[#1a2e28] text-slate-600 dark:text-gray-300'
                    }`}
                    onClick={(e) => handleNavClick(e, item.id)}
                  >
                    <span className={`material-symbols-outlined text-xl ${activeSection === item.id ? 'text-white' : 'text-slate-400 group-hover:text-primary'}`}>
                      {item.icon}
                    </span>
                    <span className={`text-sm font-medium flex-1 ${isRTL ? 'text-right' : 'text-left'} ${activeSection === item.id ? 'text-white' : ''}`}>
                      {item.label}
                    </span>
                    {activeSection === item.id && (
                        <span className={`ml-auto material-symbols-outlined text-sm ${isRTL ? 'rotate-180' : ''}`}>chevron_right</span>
                    )}
                  </button>
                ))}
              </nav>

              {/* PDF Download Button */}
              {s.catalogNav && (
                <div className="mt-6 pt-6 border-t border-gray-100 dark:border-gray-800">
                  <a
                    href={catalogPdfUrl}
                    download="AMHBM_Profile.pdf"
                    className="w-full flex items-center justify-center gap-2 bg-primary text-white py-3 px-4 rounded-xl font-bold hover:bg-primary/90 transition-colors shadow-lg shadow-primary/20"
                  >
                    <span className="material-symbols-outlined">download</span>
                    <span>{isRTL ? 'تحميل الكتالوج' : 'Download Catalog'}</span>
                  </a>
                </div>
              )}
            </div>
          </aside>

          {/* Main Content Area */}
          <section className="flex-1 min-w-0" id="main-product-content">
             {currentCategoryData ? (
                <div className="animate-fade-in">
                    <ScrollAnimation animation="fade-in" className="mb-10">
                        <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6">
                             <div>
                                <h2 className="text-xl sm:text-3xl md:text-4xl font-black tracking-tight text-slate-900 dark:text-white mb-4">
                                    {navItems.find(n => n.id === activeSection)?.label}
                                </h2>
                                <p className="text-sm sm:text-lg text-[#63887d] leading-relaxed max-w-3xl">
                                    {currentCategoryData.description}
                                </p>
                             </div>
                             <div className="flex flex-wrap gap-2">
                                {getBadges(activeSection).map((badge, idx) => (
                                    <span key={idx} className="bg-primary/10 text-primary text-[9px] sm:text-[10px] px-2 py-1 sm:px-3 sm:py-1.5 rounded-full font-bold uppercase tracking-wide border border-primary/20">
                                        {badge}
                                    </span>
                                ))}
                             </div>
                        </div>
                        
                        {/* Hero Image for Category */}
                        {currentCategoryData.image && (
                            <div className="rounded-3xl overflow-hidden h-40 sm:h-64 md:h-80 w-full relative mb-10 shadow-lg group">
                                <img 
                                    src={currentCategoryData.image} 
                                    alt={navItems.find(n => n.id === activeSection)?.label}
                                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 sm:p-8">
                                     <span className="text-white/80 font-medium text-xs sm:text-sm backdrop-blur-sm bg-black/30 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full border border-white/20">
                                        {s.overview.title}
                                     </span>
                                </div>
                            </div>
                        )}
                    </ScrollAnimation>

                    {/* Sub-items Grid */}
                    <ScrollAnimation animation="fade-up" className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {getSubcategoryItems(activeSection).map((item, index) => renderSubItem(item, index))}
                    </ScrollAnimation>
                    
                    {getSubcategoryItems(activeSection).length === 0 && (
                        <div className="text-center py-20 bg-gray-50 dark:bg-[#1a2e28] rounded-3xl border border-dashed border-gray-300 dark:border-gray-700">
                            <span className="material-symbols-outlined text-4xl text-gray-400 mb-2">inventory_2</span>
                            <p className="text-gray-500 dark:text-gray-400">
                              {isRTL ? 'لا توجد عناصر متاحة في هذه الفئة بعد.' : 'No items available in this category yet.'}
                            </p>
                        </div>
                    )}
                </div>
             ) : (
                 <div className="flex items-center justify-center h-96">
                     <p>{isRTL ? 'الفئة غير موجودة.' : 'Category not found.'}</p>
                 </div>
             )}
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Service;